// components
import { Modal } from "antd";
import React, { useEffect } from "react";
import { Provider as KeepAliveProvider } from "react-keep-alive";
import { useDispatch, useSelector } from "react-redux";
import "./app.scss";
import BtnTownDropDown from "./components/BtnTownDropDown";
import ButtonModalClose from "./components/ButtonModalClose";
import ExitConfirm from "./components/ExitConfirm";
import PrizePopUp from "./components/PrizePopUp";
import ToolTipPortion from "./components/ToolTipPortion";
import ToolTipPortionStatic from "./components/ToolTipPortionStatic";
import TownFormWrapper from "./components/TownFormWrapper";
import TownGallery from "./components/TownGallery";
import TownHeading from "./components/TownHeading";
import TownMap from "./components/TownMap";
import TownPrize from "./components/TownPrize";
import TownSlider from "./components/TownSlider";
import UnsureTable from "./components/UnsureTable";
import CloseTable from "./components/UnsureTable/closeTable";
import {
  fetchCategoriesAsync,
  fetchLatestHouseImages,
  fetchTownImagesAsync,
  fetchTownListAsync,
  setCurrentModal,
  setImgId,
  setTooltipData,
  toggleModal,
} from "./store/slices/GlobalSlice";
import { handleToolTip } from "./utils/events";

const queryString = require("query-string");

window.addEventListener("DOMContentLoaded", () => {
  handleSetHeightIframe();
  window.addEventListener("resize", () => handleSetHeightIframe());
});

const handleSetHeightIframe = () => {
  let currentWindowHeight = window.document.querySelector("#root").clientHeight;
  let outerIframe = window.parent;
  const mapTownWrapper =
    outerIframe.document.querySelector("#map-town-wrapper");

  if (!mapTownWrapper) return;
  document.querySelector("body").style.height = `${currentWindowHeight}px`;
  document.querySelector("body").style.overflow = `hidden`;
  mapTownWrapper.style.height = `${currentWindowHeight}px`;
};

const App = (props) => {
  const dispatch = useDispatch();

  const {
    modalVisible,
    isExitConfirmVisible,
    currentModal,
    isUnsureVisible,
    townList,
    isMouseOver,
  } = useSelector((state) => state.globalSlice);

  useEffect(() => {
    dispatch(fetchTownListAsync());
  }, []);

  useEffect(() => {
    dispatch(fetchCategoriesAsync());
  }, []);

  useEffect(() => {
    dispatch(fetchLatestHouseImages());
  }, []);

  useEffect(() => {
    loadImgDetails();
  }, []);

  useEffect(() => {
    if (townList?.length === 0 || isMouseOver) return;
    let firstCount = false;

    if (!firstCount) {
      dispatch(setTooltipData(townList[0]?.id));
      handleToolTip(townList[0]);
    }

    firstCount = true;

    const intervalId = setInterval(() => {
      let randomTown = Math.floor(Math.random() * 10);
      let pickRandomTown = townList[randomTown];

      dispatch(setTooltipData(pickRandomTown?.id));
      handleToolTip(pickRandomTown);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [townList, isMouseOver]);

  const loadImgDetails = () => {
    const parsed = queryString.parse(window.location.search);
    if (window.location.search && typeof parsed.imgDetails != "undefined") {
      //queryString
      const imgData = parsed.imgDetails.split("|");
      window.imgUrl = imgData[2];

      dispatch(setImgId(imgData[0]));
      dispatch(fetchTownImagesAsync(imgData[1]));
      dispatch(toggleModal());
      dispatch(setCurrentModal("townSlider"));
    }
  };

  const renderModal = () => {
    switch (currentModal) {
      case "prize":
        return <PrizePopUp />;

      case "townSlider":
        return <TownSlider />;

      case "formWrapper":
        return (
          <KeepAliveProvider include={["TownUpload", "Categories"]}>
            <TownFormWrapper />
          </KeepAliveProvider>
        );
    }
  };

  const backgroundImage =
    process.env.NODE_ENV == "development"
      ? `url(${require("@/assets/images/banner.png")})`
      : `url(${window.location.origin}/wp-content/uploads/2021/09/banner.png)`;

  return (
    <>
      <div
        className="app-wrapper bg-no-repeat bg-cover bg-center pb-24 md:pb-0"
        style={{
          // backgroundImage: `url(${require("@/assets/images/banner.png")})`,
          backgroundImage: backgroundImage,
        }}
      >
        <main className="container mx-auto pt-8 pb-16 px-3 flex flex-col items-center justify-center">
          <div className="relative w-full">
            <TownHeading />

            <ToolTipPortionStatic />

            <TownMap />
            {/* <TownPrize /> */}
            <BtnTownDropDown />
          </div>
          <TownGallery />

          <ToolTipPortion />

          <Modal
            // title=""
            // onOk={actions.setPrizeModalVisible}
            // onCancel={handleOnCancle}
            centered
            style={{ top: 20 }}
            visible={modalVisible}
            footer={null}
            bodyStyle={{ padding: 0 }}
            width={`100%`}
            closeIcon={<ButtonModalClose />}
            className="prize-popup max-w-1020"
          >
            <div
              className={`bg-sgbc-yellow-200 rounded-2xl py-20 relative ${
                currentModal === "formWrapper" || currentModal === "prize"
                  ? "md:px-10"
                  : "md:px-24"
              } px-4 text-sgbc-black-800`}
            >
              {renderModal()}
            </div>
          </Modal>

          <Modal
            centered
            visible={isExitConfirmVisible}
            style={{ top: 20 }}
            footer={null}
            bodyStyle={{ padding: 0 }}
            width={`100%`}
            className="prize-popup max-w-3xl"
          >
            <div className="bg-sgbc-yellow-200 rounded-2xl py-20 px-4 md:px-10 text-sgbc-black-800">
              <ExitConfirm />
            </div>
          </Modal>

          <Modal
            centered
            visible={isUnsureVisible}
            style={{ top: 20 }}
            footer={null}
            bodyStyle={{ padding: 0 }}
            closeIcon={<CloseTable />}
            width={`100%`}
            className="prize-popup max-w-3xl"
          >
            <div className="bg-sgbc-yellow-200 rounded-2xl py-20 px-4 md:px-10 text-sgbc-black-800">
              <UnsureTable />
            </div>
          </Modal>
        </main>
      </div>
    </>
  );
};

App.propTypes = {};

export default App;
